import React from 'react';
import './index.scss';

interface IProps {
  visible: boolean;
  onClose(): void;
  hideClose?:boolean;
}

export class Dialog extends React.Component<IProps> {
  handleClose(e: React.MouseEvent<HTMLImageElement>) {
    this.props.onClose();
  }

  render() {
    if (this.props.visible) {
      return (
        <div className="dialog-container">
          <div className="dialog">
            <div className="dialog-close">
              {
                !this.props.hideClose
                ?
                  <img
                    src={require('../../assets/close.png')}
                    alt=""
                    onClick={this.handleClose.bind(this)}
                  />
                  :
                  null
              }
            </div>
            {this.props.children}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
